import Vue from 'vue'

const mutations = {

  /**
   * @param state
   * @param user
   * @constructor
   */
  LOST_HB (state, devicedesktops) {
    for (const devicedesktop of devicedesktops) {
      const desktopIndex = state.desktop_list.findIndex(desktop => desktop.id === devicedesktop.id)
      const desktop = JSON.parse(JSON.stringify(state.desktop_list[desktopIndex]))
      desktop.alive = false
      desktop.updatedAt = Date.now()
      Vue.set(state.desktop_list, desktopIndex, desktop)
    }
  },
  RECOVERED_HB (state, devicedesktops) {
    for (const devicedesktop of devicedesktops) {
      const desktopIndex = state.desktop_list.findIndex(desktop => desktop.id === devicedesktop.id)
      const desktop = JSON.parse(JSON.stringify(state.desktop_list[desktopIndex]))
      desktop.alive = true
      desktop.updatedAt = Date.now()
      Vue.set(state.desktop_list, desktopIndex, desktop)
    }
  },
  UPDATE_PROGRESS (state, contentdownload) {
    let contentDownloadPreviousIndex = state.content_downloads.findIndex(cd => cd.id === contentdownload.id)
    if (contentDownloadPreviousIndex === -1) {
      return state.content_downloads.push(contentdownload)
    }
    state.content_downloads[contentDownloadPreviousIndex].progress = contentdownload.progress
    state.content_downloads[contentDownloadPreviousIndex].updatedAt = contentdownload.updatedAt
  },
  REMOVE_FROM_DEVICELIST (state, device) {
    let olddeviceindex = state.device_list.findIndex(olddevice => olddevice.id === device.id)
    if (olddeviceindex === -1) return
    state.device_list.splice(olddeviceindex, 1)
  },
  SET_DEVICELIST (state, devices) {
    devices.map(obj => Object.freeze(obj))
    Vue.set(state, 'device_list', devices)
  },
  SET_DESKTOPLIST (state, desktops) {
    desktops.map(obj => Object.freeze(obj))
    Vue.set(state, 'desktop_list', desktops)
  },
  SET_DEVICE_DESKTOP_GROUPS (state, deviceDesktopGroups) {
    deviceDesktopGroups.map(obj => Object.freeze(obj))
    Vue.set(state, 'device_desktop_groups', deviceDesktopGroups)
  },
  ADD_DEVICE_DESKTOP_GROUP (state, group) {
    state.device_desktop_groups.push(group)
  },
  UPDATE_DEVICE_DESKTOP_GROUP (state, group) {
    const groupIndex = state.device_desktop_groups.findIndex(g => g.id === group.id)
    Vue.set(state.device_desktop_groups, groupIndex, group)
  },
  SET_CONTENT_DOWNLOADS (state, contentDownloads) {
    contentDownloads.map(obj => Object.freeze(obj))
    if (state.content_downloads.length > 0) state.content_downloads = []
    Vue.set(state, 'content_downloads', contentDownloads)
  },
  SET_DESKTOPS_AFFECTED (state, desktopsAffected) {
    desktopsAffected.map(obj => Object.freeze(obj))
    if (state.desktops_affected.length > 0) state.desktops_affected = []
    Vue.set(state, 'desktops_affected', desktopsAffected)
  },
  DELETE_DESKTOP_AFFECTED (state, desktopAffectedId) {
    const index = state.desktops_affected.findIndex(da => da.id === desktopAffectedId)
    if (index > -1) {
      state.desktops_affected.splice(index, 1)
    }
  },
  ADD_DESKTOP_AFFECTED (state, desktopAffected) {
    Object.freeze(desktopAffected)
    if (state.desktops_affected.findIndex(da => da.id === desktopAffected.id) === -1) {
      state.desktops_affected.push(desktopAffected)
    }
  },
  DELETE_CONTENT_DOWNLOAD (state, contentDownloadId) {
    console.error('DELETE_CONTENT_DOWNLOAD')
    const index = state.content_downloads.findIndex(cd => cd.id === contentDownloadId)
    state.content_downloads.splice(index, 1)
  },
  SET_DEVICELIST_COUNT (state, count) {
    state.devices_count = count
  },
  UPDATE_DEVICELIST (state, device) {
    const olddeviceindex = state.device_list.findIndex(olddevice => olddevice.id === device.id)
    if (state.device_list.length === 0 || olddeviceindex === -1) {
      return state.device_list.push(device)
    }
    Vue.set(state.device_list, olddeviceindex, device)
  },
  UPDATE_DESKTOP_HB (state, data) {
    for (const payload of data) {
      const desktopIndex = state.desktop_list.findIndex(dtp => dtp.id === payload.deviceDesktopId)
      Vue.set(state.desktop_list, desktopIndex, payload.hb)
    }
  },
  UPDATE_DESKTOP (state, desktop) {
    const desktopIndex = state.desktop_list.findIndex(dtp => dtp.id === desktop.id)
    if (!desktop.concatedname) {
      const deviceId = desktop.Device.id ? desktop.Device.id : desktop.Device
      desktop.concatedname = state.device_list.find(device => device.id === deviceId).name + desktop.name
    }
    Vue.set(state.desktop_list, desktopIndex, desktop)
  },
  ADD_MONITOR (state, monitor) {
    const deviceindex = state.device_list.findIndex(device => device.id === monitor.Device.id)
    if (deviceindex === -1) {
      return console.error('no deviceindex found in ADD_MONITOR')
    }
    state.device_list[deviceindex].DeviceMonitors.push(monitor)
  },
  // Used in EditMonitorsDesktops.vue
  UPDATE_DESKTOPS_IN_DEVICE (state, deviceUpdated) {
    const deviceindex = state.device_list.findIndex(device => device.id === deviceUpdated.id)
    Vue.set(state.device_list, deviceindex, Object.freeze(deviceUpdated))
  },
  UPDATE_DEVICE_DESKTOP_GROUPS (state, group) {
    const groupIndex = state.device_desktop_groups.findIndex(gr => gr.id === group.id)
    if (groupIndex === -1) {
      return state.device_desktop_groups.push(group)
    }
    state.device_desktop_groups.splice(groupIndex, 1, group)
  },
  ADD_DATE_RESTRICTION (state, restriction) {
    let deviceindex = state.device_list.findIndex(device => device.id === restriction.Device.id)
    if (deviceindex === -1) return
    state.device_list[deviceindex].Device_DateRestrictions.push(restriction)
  },
  DELETE_DATE_RESTRICTION (state, restrictionDeleted) {
    let deviceindex = state.device_list.findIndex(device => device.id === restrictionDeleted.Device.id)
    if (deviceindex === -1) return
    let restrictionindex = state.device_list[deviceindex].Device_DateRestrictions.findIndex(command => command.id === restrictionDeleted.id)
    state.device_list[deviceindex].Device_DateRestrictions.splice(restrictionindex, 1)
  },
  ADD_DEVICE_TAG_TO_NETWORK_DEVICE_TAGS (state, tag) {
    state.device_tags_unused.push(tag)
  },
  CLEAR_DEVICE_TAGS (state) {
    Vue.set(state, 'device_tags', [])
  },
  async SET_DEVICE_TAGS (state, tags) {
    // tags.map(obj => Object.freeze(obj))
    Vue.set(state, 'device_tags', tags)
    // for (const device of state.device_list) {
    //   if (!device.DeviceTags) return
    //   for (const tagInDevice of device.DeviceTags) {
    //     let tagInList = state.device_tags.find(tag => tag.id === tagInDevice.id)
    //     if (!tagInList) {
    //       let tagToInsert = tagInDevice
    //       tagToInsert.device = []
    //       tagToInsert.device.push(device.id)
    //       state.device_tags.push(tagToInsert)
    //     } else {
    //       tagInList.device.push(device.id)
    //     }
    //   }
    // }
    state.device_tags.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
  },
  SET_DEVICE_TAGS_UNUSED (state, tags) {
    Vue.set(state, 'device_tags_unused', tags)
  },
  ADD_TAG_TO_DEVICE (state, data) {
    const deviceWithTags = state.device_list.find(device => device.id === data[1])
    let tag
    tag = state.device_tags.find(tag => tag.id === data[0])
    // this was previously unused tag in network, move it to filter, remove from device_tags_unused
    if (!tag) {
      tag = state.device_tags_unused.find(tag => tag.id === data[0])
      const unusedTagIndex = state.device_tags_unused.findIndex(tag => tag.id === data[0])
      state.device_tags_unused.splice(unusedTagIndex, 1)
      tag.device = []
      state.device_tags.push(tag)
    }
    // push new tag to device
    // if (!deviceWithTags.DeviceTags.find(dtag => dtag.id === tag.id)) deviceWithTags.DeviceTags.push(tag)
    // adjust filter
    const tagInFilterIndex = state.device_tags.findIndex(dt => dt.id === tag.id)
    state.device_tags[tagInFilterIndex].device.push(deviceWithTags.id)
    // still ugly hack to refresh VUEX->DOM
    Vue.set(state.device_tags, tagInFilterIndex, state.device_tags[tagInFilterIndex])
  },
  DELETE_TAG_FROM_DEVICE (state, data) {
    // const deviceWithTag = state.device_list.find(device => device.id === data[1])
    // const tagIndexInDevice = deviceWithTag.DeviceTags.findIndex(tag => tag.id === data[0])
    // deviceWithTag.DeviceTags.splice(tagIndexInDevice, 1)
    // adjust device_tags
    const tagInFilter = state.device_tags.find(tag => tag.id === data[0])
    // it is last device with this tag, remove tag from filter, add to device_tags_unused
    if (tagInFilter.device.length === 1) {
      const unusedTagIndex = state.device_tags.findIndex(tag => tag.id === data[0])
      state.device_tags.splice(unusedTagIndex, 1)
      delete tagInFilter.device
      state.device_tags_unused.push(tagInFilter)
    } else {
    // remove device from tag filter
      const deviceIndexToBeRemoved = tagInFilter.device.findIndex(d => d === data[1])
      tagInFilter.device.splice(deviceIndexToBeRemoved, 1)
      const tagInFilterIndex = state.device_tags.findIndex(tag => tag.id === data[0])
      // still ugly hack to refresh VUEX->DOM
      Vue.set(state.device_tags, tagInFilterIndex, tagInFilter)
    }
  },
  CLEAR_TAGS_FROM_DEVICE (state, deviceId) {
    const tagsForDevice = state.device_tags.filter(dt => dt.device.includes(deviceId))
    for (const tagForDevice of tagsForDevice) {
      tagForDevice.device.splice(tagForDevice.device.findIndex(d => d === deviceId), 1)
    }
  },
  TOGGLE_TAG_FILTER_VISIBLE (state) {
    Vue.set(state, 'show_tag_filter', !state.show_tag_filter)
  },
  /** FILTER */
  SET_TAGS_IN_FILTER (state, data) {
    let side = data[0]
    let tags = data[1]
    Vue.set(state.device_filter[side], 'deviceTags', tags)
  },
  TOGGLE_TAG_IN_FILTER (state, data) {
    let side = data[0]
    let tag = data[1]
    let tagIndex =
      state.device_filter[side].deviceTags
        .findIndex(filterTag => filterTag.id === tag.id)
    if (tagIndex === -1) {
      state.device_filter[side].deviceTags.push(tag)
    } else {
      state.device_filter[side].deviceTags.splice(tagIndex, 1)
    }
    state.pagination[side].page = 1
    if (state.device_filter[side].deviceTags.length < 2) {
      state.device_filter[side].deviceTagsAll = false
    }
  },
  TOGGLE_TYPE_IN_FILTER (state, data) {
    let side = data[0]
    let type = data[1]
    if (!type) return
    let typeIndex =
      state.device_filter[side].deviceTypes
        .findIndex(filterType => filterType.name === type.name)
    if (typeIndex === -1) {
      state.device_filter[side].deviceTypes.push(type)
    } else {
      state.device_filter[side].deviceTypes.splice(typeIndex, 1)
    }
    state.pagination[side].page = 1
  },
  SET_TYPE_IN_FILTER (state, data) {
    let side = data[0]
    let type = data[1]
    if (!type) return
    state.device_filter[side].deviceTypes = []
    state.device_filter[side].deviceTypes.push(type)
    state.pagination[side].page = 1
  },
  SET_TAG_ALLANY_IN_FILTER (state, data) {
    let side = data[0]
    let allany = data[1]
    state.device_filter[side].deviceTagsAll = allany
    state.pagination[side].page = 1
  },
  CLEAR_TAG_FILTER (state, side) {
    state.device_filter[side].deviceTags = []
    state.device_filter[side].deviceTagsAll = false
  },
  CLEAR_TYPE_FILTER (state, side) {
    state.device_filter[side].deviceTypes = []
  },
  /** SELECTIONS */
  ADD_DESKTOPS_SELECTED_RIGHT (state, desktops) {
    Vue.set(state, 'desktops_selected_right', desktops)
  },
  TOGGLE_DESKTOP_SELECTED_RIGHT (state, desktop) {
    const desktopIndex = state.desktops_selected_right.findIndex(dtp => dtp.id === desktop.id)
    if (desktopIndex === -1) {
      state.desktops_selected_right.push(desktop)
    } else {
      state.desktops_selected_right.splice(desktopIndex, 1)
    }
  },
  CLEAR_DESKTOPS_SELECTED_RIGHT (state) {
    state.desktops_selected_right = []
  },
  REMOVE_DESKTOP_SELECTED_RIGHT (state, desktop) {
    const desktopIndex = state.desktops_selected_right.findIndex(dtp => dtp.id === desktop.id)
    if (desktopIndex !== -1) {
      state.desktops_selected_right.splice(desktopIndex, 1)
    }
  },
  ADD_DESKTOP_GROUPS_SELECTED_RIGHT (state, desktopgroups) {
    Vue.set(state, 'desktop_groups_selected_right', desktopgroups)
    const desktops = desktopgroups.map(dg => dg.DeviceDesktops)[0]
    Vue.set(state, 'desktops_selected_right', desktops)
  },
  TOGGLE_DESKTOP_GROUP_SELECTED_RIGHT (state, desktopgroup) {
    const desktopGroupIndex = state.desktop_groups_selected_right.findIndex(dtg => dtg.id === desktopgroup.id)
    if (desktopGroupIndex === -1) {
      state.desktop_groups_selected_right.push(desktopgroup)
      for (const desktop of desktopgroup.DeviceDesktops) {
        if (!state.desktops_selected_right.find(dd => dd.id === desktop.id)) {
          state.desktops_selected_right.push(desktop)
        }
      }
    } else {
      state.desktop_groups_selected_right.splice(desktopGroupIndex, 1)
      for (const desktop of desktopgroup.DeviceDesktops) {
        // console.log('2', desktop.id, state.desktops_selected_right.findIndex(dtp => dtp.id === desktop.id))
        this.commit('Device/REMOVE_DESKTOP_SELECTED_RIGHT', desktop, { root: true })
      }
    }
  },
  CLEAR_DESKTOP_GROUPS_SELECTED_RIGHT (state) {
    state.desktop_groups_selected_right = []
  },
  /** QUICK FILTERS */
  TOGGLE_FILTER_BY_STATUS (state, data) {
    const statusActiveIndex = state.localStatusDeviceFilters[data.side].findIndex(lsdf => lsdf === data.status)
    if (statusActiveIndex === -1) {
      state.localStatusDeviceFilters[data.side].push(data.status)
    } else {
      state.localStatusDeviceFilters[data.side].splice(statusActiveIndex, 1)
    }
  },
  TOGGLE_FILTER_BY_STATUS_HB (state, data) {
    if (state.localStatusDeviceFilters[data.side].includes('activeHB')) {
      state.localStatusDeviceFilters[data.side].splice(state.localStatusDeviceFilters[data.side].findIndex(lsdf => lsdf === 'activeHB'), 1)
      state.localStatusDeviceFilters[data.side].push('inactiveHB')
      return
    }
    if (state.localStatusDeviceFilters[data.side].includes('inactiveHB')) {
      state.localStatusDeviceFilters[data.side].splice(state.localStatusDeviceFilters[data.side].findIndex(lsdf => lsdf === 'inactiveHB'), 1)
      state.localStatusDeviceFilters[data.side].push('neveractiveHB')
      return
    }
    if (state.localStatusDeviceFilters[data.side].includes('neveractiveHB')) {
      state.localStatusDeviceFilters[data.side].splice(state.localStatusDeviceFilters[data.side].findIndex(lsdf => lsdf === 'neveractiveHB'), 1)
      return
    }
    if (!state.localStatusDeviceFilters[data.side].includes('activeHB')) {
      state.localStatusDeviceFilters[data.side].push('activeHB')
    }
  },
  TOGGLE_FILTER_BY_STATUS_DEPLOYED (state, data) {
    if (state.localStatusDeviceFilters[data.side].includes('inactiveDeployed')) {
      state.localStatusDeviceFilters[data.side].splice(state.localStatusDeviceFilters[data.side].findIndex(lsdf => lsdf === 'inactiveDeployed'), 1)
      state.localStatusDeviceFilters[data.side].push('deployed')
      return
    }
    if (state.localStatusDeviceFilters[data.side].includes('deployed')) {
      state.localStatusDeviceFilters[data.side].splice(state.localStatusDeviceFilters[data.side].findIndex(lsdf => lsdf === 'deployed'), 1)
      state.localStatusDeviceFilters[data.side].push('unDeployed')
      return
    }
    if (state.localStatusDeviceFilters[data.side].includes('unDeployed')) {
      state.localStatusDeviceFilters[data.side].splice(state.localStatusDeviceFilters[data.side].findIndex(lsdf => lsdf === 'unDeployed'), 1)
      state.localStatusDeviceFilters[data.side].push('inactiveDeployed')
      return
    }
    if (!state.localStatusDeviceFilters[data.side].includes('deployed')) {
      state.localStatusDeviceFilters[data.side].push('deployed')
    }
  },
  TOGGLE_FILTER_BY_STATUS_ALERTED (state, data) {
    if (state.localStatusDeviceFilters[data.side].includes('inactiveAlerted')) {
      state.localStatusDeviceFilters[data.side].splice(state.localStatusDeviceFilters[data.side].findIndex(lsdf => lsdf === 'inactiveAlerted'), 1)
      state.localStatusDeviceFilters[data.side].push('alerted-notice')
      return
    }
    if (state.localStatusDeviceFilters[data.side].includes('alerted-notice')) {
      state.localStatusDeviceFilters[data.side].splice(state.localStatusDeviceFilters[data.side].findIndex(lsdf => lsdf === 'alerted-notice'), 1)
      state.localStatusDeviceFilters[data.side].push('alerted-warning')
      return
    }
    if (state.localStatusDeviceFilters[data.side].includes('alerted-warning')) {
      state.localStatusDeviceFilters[data.side].splice(state.localStatusDeviceFilters[data.side].findIndex(lsdf => lsdf === 'alerted-warning'), 1)
      state.localStatusDeviceFilters[data.side].push('alerted-error')
      return
    }
    if (state.localStatusDeviceFilters[data.side].includes('alerted-error')) {
      state.localStatusDeviceFilters[data.side].splice(state.localStatusDeviceFilters[data.side].findIndex(lsdf => lsdf === 'alerted-error'), 1)
      state.localStatusDeviceFilters[data.side].push('inactiveAlerted')
      return
    }
    if (!state.localStatusDeviceFilters[data.side].includes('alerted-notice')) {
      state.localStatusDeviceFilters[data.side].push('alerted-notice')
    }
  },
  CLEAR_DESKTOPS_SELECTED_LEFT (state) {
    state.desktops_selected_left = []
  },
  PAGINATION_SET_LIMIT (state, data) {
    state.pagination[data[0]].limit = data[1]
  },
  PAGINATION_SET_PAGE (state, data) {
    state.pagination[data[0]].page = data[1]
  },
  PAGINATION_SET_LIMIT_GROUPS (state, data) {
    state.pagination_groups[data[0]].limit = data[1]
  },
  PAGINATION_SET_PAGE_GROUPS (state, data) {
    state.pagination_groups[data[0]].page = data[1]
  },
  UPDATE_SEARCH_STRING (state, string) {
    state.search_by_string = string
  },
  SET_DESKTOPS_COMPONENT_RIGHT (state, componentName) {
    state.desktops_component_right = componentName
  },
  // RELOADING STATE
  SET_RELOADING_DEVICES (state, status) {
    Vue.set(state, 'devices_reloading', status)
  },
  // DESKTOP CACHE
  SET_DESKTOP_CACHE (state, desktops) {
    Vue.set(state, 'desktops_cache', desktops)
  }
}

export default mutations



//////////////////
// WEBPACK FOOTER
// ./state/device/device.mutations.js
// module id = null
// module chunks = 